/* @ngInject */
const editFieldsModal = (
  $uibModal,
  wagonRequest,
  utils,
  $$owner,
  toaster
) => {
  const self = {}

  self.open = (_fieldName, _fieldLabel, _data, _filteredData) => {
    return $uibModal.open({
      template: require('./editOwners.html'),
      resolve: {
        data: () => {
          return _data
        },
        filteredData: () => {
          return _filteredData
        },
        fieldName: () => {
          return _fieldName
        },
        fieldLabel: () => {
          return _fieldLabel
        },
      },
      /* @ngInject */
      controller: (
        $scope,
        $uibModalInstance,
        fieldName,
        fieldLabel,
        wagonFields,
        data,
        filteredData,
      ) => {
        $scope.fieldValue = {}
        $scope.fieldName = fieldName
        $scope.fieldLabel = fieldLabel
        $scope.fieldsOptions = wagonFields
        $scope.filteredData = filteredData
        $scope.data = data
        $scope.owner = {}
        $scope.owners = []

        $$owner.request.getAll()
          .then(response => {
            $scope.owners = response.owners || []
            $scope.$apply()
          })

        $scope.submit = async (ownerId) => {
          const loopPromises = []

          for (var i = 0; i < filteredData.length; i++) {
            try {
              const updateData = {
                ownerId: ownerId,
                id: filteredData[i].id,
              }

              loopPromises.push(wagonRequest.updateOwner(updateData))
            } catch (error) {
              toaster.error(error)
            }
          }

          loopPromises.forEach(async (promise) => {
            const response = await promise
            utils.updateFromArray(data, response.wagon)
          })

          $uibModalInstance.close()
        }

        $scope.cancel = () => {
          $uibModalInstance.close()
        }
      },
    })
  }

  return self
}
export default editFieldsModal



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/wagon/modals/editOwners.modal.js